<template>
  <!-- 运单配载 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickBtnOperate(3, {})">直送</el-button>
        <!-- <el-button class="glo_btnItems" @click="clickBtnOperate(4, {})">转仓</el-button> -->
        <el-button class="glo_btnItems" @click="clickBtnOperate(5, {})">批量外发</el-button>
        <el-button class="glo_btnItems" @click="clickBtnOperate(6, {})">批量修改配载</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition ref="queryForm" :More="isHaseMore" :formConfig="queryCondditionDatas"></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="180px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="
                  scope.row.dispatchStatus !==
                  'yi_pai_che:dispatch_status'
                "
                class="rbtns"
                @click.stop="clickBtnOperate(1, scope.row)"
              >外发</el-button>
              <el-button v-else class="rbtns" disabled>{{ scope.row.dispatchStatusShow || "" }}</el-button>
              <el-button class="rbtns" @click.stop="clickBtnOperate(2, scope.row)">修改配载</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 外发 -->
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="110px">
          <el-form-item label="运单号:" required v-if="keyOperate == 2">
            <el-input v-model="waybillNumber" disabled></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="配载类型:" v-if="keyOperate == 2 || keyOperate == 6">
            <el-select filterable clearable v-model="dialogForm1.transportPlan" placeholder="请输入">
              <el-option v-for="(item, index) in departure_type_list" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="配载网点:">
            <el-select
              v-model="dialogForm1.dispatchDeptId"
              placeholder="输入网点进行匹配"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethodDept(e);
                }
              "
              @focus="
                (e) => {
                  focusMethodDept();
                }
              "
              @clear="remoteMethodDept('')"
            >
              <el-option v-for="(item, index) in businessDeptIdArr" :key="index" :label="item.departmentName" :value="item.deptId" />
            </el-select>
          </el-form-item>
          <el-form-item label="承运商:" required>
            <el-select
              v-model="dialogForm1.carrierId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethodCarrier(e);
                }
              "
              @focus="
                (e) => {
                  focusMethodCarrier(e);
                }
              "
              @change="
                (e) => {
                  changeMethodCarrier(e);
                }
              "
              @clear="remoteMethodCarrier('')"
            >
              <el-option v-for="(item, index) in changeCarrierList" :key="index" :label="item.carrierName" :value="item.carrierId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承运商网点:" required>
            <el-select v-model="dialogForm1.carrierDeptId" @change="changeMethodCarrier1" placeholder="请选择" clearable filterable>
              <el-option v-for="(item, index) in CarrierDeptListList" :key="index" :label="item.deptName" :value="item.carrierDeptId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承运商电话:">
            <el-input v-model="dialogForm1.phone" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item style="width: 100%; border: 0" label="承运商地址:">
            <div class="disFlexs">
              <el-select class="selectAddress" v-model="dialogForm1.provinceName" placeholder="请选择省" clearable filterable @change="changeProvince">
                <el-option v-for="(item, index) in SuperiorRegionList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-select class="selectAddress" v-model="dialogForm1.cityName" placeholder="请选择市" clearable filterable @change="changeCity">
                <el-option v-for="(item, index) in cityNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-select class="selectAddress" v-model="dialogForm1.areaName" placeholder="请选择区" clearable filterable>
                <el-option v-for="(item, index) in areaNameList" :key="index" :label="item.districtName" :value="item.districtName"></el-option>
              </el-select>
              <el-input class="selectAddress addressDetails" v-model="dialogForm1.address" placeholder="请输入详细地址" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="提货方式:">
            <el-select filterable clearable v-model="dialogForm1.outgoingReceiveMethodConfDictId" placeholder="请选择">
              <el-option v-for="(item, index) in OUTTakeMethodList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货方式:" required>
            <el-select filterable clearable v-model="dialogForm1.outgoingSendMethodConfDictId" placeholder="请输入">
              <el-option v-for="(item, index) in OUTsendMethodList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计费方式:">
            <div style=" display: flex;align-items: center;">
              <el-select filterable clearable v-model="dialogForm1.formulaBillingWeightId" placeholder="请选择">
                <el-option v-for="(item, index) in out_going_billing_method_list" :key="index" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
              <el-button class="jsBtns glo_bgcMainColor" @click="clickSharing_sendFee">计算</el-button>
            </div>
          </el-form-item>
          <el-form-item label="预计送货费:">
            <el-input v-model="dialogForm1.sendFee" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="预计运费:">
            <el-input v-model="dialogForm1.freight" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="其他费用:">
            <el-input v-model="dialogForm1.otherFee" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" label="交货日期:">
            <el-date-picker v-model="dialogForm1.sendTime" class="input" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="回单要求:">
            <div class="glo_disFlex" style="padding-right: 3px">
              <el-select style="width: 180px" v-model="dialogForm1.rnRequireConfDictId" placeholder="请选择" filterable clearable @change="changernRequireName">
                <el-option v-for="(item, index) in rnrderRequireList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
              </el-select>
              <el-input class="miniInput" v-model="dialogForm1.rnRequireCount"></el-input>份
            </div>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="dialogForm1.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 转仓 -->
    <myDialog :diaWidth="diaWidth2" :dialogTitle="dialogTitle2" :isShowDialog="isShowDialog2" @handleCloseDia="handleCloseDia2" @diaCancelBtn="handleCloseDia2" @diaConfirmBtn="diaConfirmBtn2">
      <div class="formbox" v-if="isShowDialog2">
        <el-form class="glo_formBox" label-width="110px">
          <div v-if="keyOperate == 5" style="padding: 16px;width: 100%;">
            <span>确认把所选单据标记为外发吗？</span>
          </div>
          <el-form-item label="配载网点:">
            <el-select
              v-model="dialogForm2.dispatchDeptId"
              placeholder="输入网点进行匹配"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethodDept(e);
                }
              "
              @focus="
                (e) => {
                  focusMethodDept();
                }
              "
              @clear="remoteMethodDept('')"
            >
              <el-option v-for="(item, index) in businessDeptIdArr" :key="index" :label="item.departmentName" :value="item.deptId" />
            </el-select>
          </el-form-item>
          <el-form-item label="转仓仓库:" v-if="keyOperate == 4">
            <el-select
              v-model="dialogForm2.storageId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'storage', 'storageList');
                }
              "
              @focus="
                (e) => {
                  focusMethod('storage', 'storageList');
                }
              "
              @clear="remoteMethod('', 'storage', 'storageList')"
            >
              <!-- @change="
                (e) => {
                  changeMethod(e, 'storageList', 'intoDeptName');
                }
              "-->
              <el-option v-for="(item, index) in storageList" :key="index" :label="item.name" :value="item.documentId" />
            </el-select>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" v-model="dialogForm2.remarks" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "运单配载列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "DispatchCar_WaybillLoading", //  页面标识
      reportFiledsNumber: "admin_wait_dispatch_waybill_list", // 动态 条件、表头

      isShowDialog1: false,
      dialogTitle1: "外发",
      diaWidth1: "60%",
      dialogForm1: {
        transportPlan: "",
        address: "",
        areaName: "",
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        cityName: "",
        formulaBillingWeight: "",
        formulaBillingWeightId: "",
        freight: "",
        otherFee: "",
        outgoingReceiveMethod: "",
        outgoingReceiveMethodConfDictId: "",
        outgoingSendMethod: "",
        outgoingSendMethodConfDictId: "",
        phone: "",
        provinceName: "",
        remarks: "",
        rnRequireConfDictId: "",
        rnRequireCount: "",
        rnRequireName: "",
        sendFee: "",
        sendTime: "",
        dispatchDeptName: "",
        dispatchDeptId: "",
      },

      isShowDialog2: false,
      dialogTitle2: "转仓",
      diaWidth2: "60%",
      dialogForm2: {
        remarks: "",
        storageId: "",
        storageName: "",
        dispatchDeptName: "",
        dispatchDeptId: "",
      },
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商
      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货方式
      out_going_billing_method_list: [], //外发提货方式
      rnrderRequireList: [], //回单类型
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      departure_type_list: [
        {
          label: "直送",
          value: "zhi_song:transport_plan",
        },
        {
          label: "转仓",
          value: "ru_cang:transport_plan",
        },
        {
          label: "外发",
          value: "wai_fa:transport_plan",
        },
      ],
      keyOperate: 1,
      storageList: [], //入仓仓库
      waybillNumber: "",
      businessDeptIdArr: [],
    };
  },
  mounted() {
    this.getConfDictValDownList("out_going_take_method"); //提货方式
    this.getConfDictValDownList("out_going_send_method"); //送货方式
    this.getConfDictValDownList("out_going_billing_method"); //外发计费方式
    this.getConfDictValDownList("rn_order_require"); //回单类型
    this.getParentName("中华人民共和国"); //默认查到各省
  },
  watch: {},
  activated() {},
  methods: {
    //网点
    focusMethodDept() {
      if (this.businessDeptIdArr.length == 0) {
        this.remoteMethodDept("");
      }
    },
    // 网点
    remoteMethodDept(deptName) {
      this.$API
        .wtl_getDeptList({
          deptName,
          deptId: "",
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.businessDeptIdArr = res.data.result?.data || [];
        });
    },
    clickBtnOperate(
      key,
      { waybillSplitId, waybillNumber, waybillDispatchId, sendTime }
    ) {
      this.keyOperate = key;
      let { departmentName, departmentId } = this.$TOOLS.getUserInfo() || "";
      switch (key) {
        case 1:
          this.dialogTitle1 = "外发";
          this.dialogForm1.waybillSplitIds = [waybillSplitId];
          this.dialogForm1.sendTime = sendTime;
          this.isShowDialog1 = true;
          this.dialogForm1.dispatchDeptName = departmentName || "";
          this.dialogForm1.dispatchDeptId = departmentId || "";
          this.remoteMethodDept(this.dialogForm1.dispatchDeptName);
          break;
        case 2:
          this.dialogTitle1 = "修改配载";
          this.waybillNumber = waybillNumber;
          this.dialogForm1.sendTime = sendTime;
          // waybillDispatchId waybillSplitId
          if (waybillDispatchId) {
            this.$API
              .getWaybillDispatchDetail({
                waybillDispatchId,
              })
              .then(async (res) => {
                let result = res.data.result || [];
                let { carrierName, carrierId, provinceName, cityName } = result;
                await this.remoteMethodCarrier(carrierName);
                if (carrierId) {
                  await this.CarrierDeptListApi(carrierId);
                }
                this.dialogForm1 = {
                  waybillDispatchIds: [waybillDispatchId],
                  transportPlan: result.transportPlan || "",
                  address: result.address || "",
                  areaName: result.areaName || "",
                  carrierDeptId: result.carrierDeptId || "",
                  carrierDeptName: result.carrierDeptName || "",
                  carrierId: result.carrierId || "",
                  carrierName: result.carrierName || "",
                  cityName: result.cityName || "",
                  formulaBillingWeight: result.formulaBillingWeight || "",
                  formulaBillingWeightId: result.formulaBillingWeightId || "",
                  freight: result.freight || "",
                  otherFee: result.otherFee || "",
                  outgoingReceiveMethod: result.outgoingReceiveMethod || "",
                  outgoingReceiveMethodConfDictId:
                    result.outgoingReceiveMethodConfDictId || "",
                  outgoingSendMethod: result.outgoingSendMethod || "",
                  outgoingSendMethodConfDictId:
                    result.outgoingSendMethodConfDictId || "",
                  phone: result.phone || "",
                  provinceName: result.provinceName || "",
                  remarks: result.remarks || "",
                  rnRequireConfDictId: result.rnRequireConfDictId || "",
                  rnRequireCount: result.rnRequireCount || "",
                  rnRequireName: result.rnRequireName || "",
                  sendFee: result.sendFee || "",
                  sendTime: result.sendTime || "",
                  dispatchDeptName: result.dispatchDeptName || departmentName,
                  dispatchDeptId: result.dispatchDeptId || departmentId,
                };
                this.getCityName(provinceName || "");
                this.getAreaName(cityName || "");
                this.remoteMethodDept(this.dialogForm1.dispatchDeptName);
                this.isShowDialog1 = true;
              });
          } else {
            this.dialogForm1.waybillDispatchIds = [];
            this.isShowDialog1 = false;
            this.$message.warning("当前运单未配载，暂不能修改");
          }
          break;
        case 3:
          this.dialogTitle2 = "直送";
          let ids2 = [];
          if (this.selectTableData.length < 1) {
            this.$message.warning("请选择需要操作的数据");
            return false;
          }
          if (
            this.selectTableData.some((item) => {
              return item.dispatchStatus == "yi_pai_che:dispatch_status";
            })
          ) {
            this.$message.warning("所操作的数据有运单已配载，暂不能直送");
            return false;
          }
          this.selectTableData.forEach((item) => {
            ids2.push(item.waybillSplitId);
          });
          this.dialogForm2.waybillSplitIds = ids2;
          this.isShowDialog2 = true;
          this.dialogForm2.dispatchDeptName = departmentName || "";
          this.dialogForm2.dispatchDeptId = departmentId || "";
          this.remoteMethodDept(this.dialogForm2.dispatchDeptName);
          break;
        case 4:
          this.dialogTitle2 = "转仓";
          let ids = [];
          if (this.selectTableData.length < 1) {
            this.$message.warning("请选择需要操作的数据");
            return false;
          }
          if (
            this.selectTableData.some((item) => {
              return item.dispatchStatus == "yi_pai_che:dispatch_status";
            })
          ) {
            this.$message.warning("所操作的数据有运单已配载，暂不能转仓");
            return false;
          }
          this.selectTableData.forEach((item) => {
            if (item.waybillDispatchId) {
              ids.push(item.waybillDispatchId);
            }
          });
          this.dialogForm2.waybillDispatchIds = ids;
          this.isShowDialog2 = true;
          this.dialogForm2.dispatchDeptName = departmentName || "";
          this.dialogForm2.dispatchDeptId = departmentId || "";
          this.remoteMethodDept(this.dialogForm2.dispatchDeptName);
          break;
        case 5:
          this.dialogTitle2 = "批量外发";
          let ids5 = [];
          if (this.selectTableData.length < 1) {
            this.$message.warning("请选择需要操作的数据");
            return false;
          }
          if (
            this.selectTableData.some((item) => {
              return item.dispatchStatus == "yi_pai_che:dispatch_status";
            })
          ) {
            this.$message.warning("所操作的数据有运单已配载，暂不能批量外发");
            return false;
          }
          this.selectTableData.forEach((item) => {
            ids5.push(item.waybillSplitId);
          });
          this.dialogForm2.waybillSplitIds = ids5;
          this.isShowDialog2 = true;
          this.dialogForm2.dispatchDeptName = departmentName || "";
          this.dialogForm2.dispatchDeptId = departmentId || "";
          this.remoteMethodDept(this.dialogForm2.dispatchDeptName);
          break;
        case 6:
          this.dialogTitle1 = "批量修改配载";
          this.dialogForm1.sendTime = sendTime;
          // waybillDispatchId waybillSplitId
          let ids6 = [];
          if (this.selectTableData.length < 1) {
            this.$message.warning("请选择需要操作的数据");
            return false;
          }
          if (
            this.selectTableData.some((item) => {
              return !item.waybillDispatchId;
            })
          ) {
            this.$message.warning("所操作的数据有运单未配载，暂不能修改");
            return false;
          }
          this.selectTableData.forEach((item) => {
            ids6.push(item.waybillDispatchId);
          });

          this.isShowDialog1 = true;
          this.dialogForm1 = {
            waybillDispatchIds: ids6,
            transportPlan: "",
            address: "",
            areaName: "",
            carrierDeptId: "",
            carrierDeptName: "",
            carrierId: "",
            carrierName: "",
            cityName: "",
            formulaBillingWeight: "",
            formulaBillingWeightId: "",
            freight: "",
            otherFee: "",
            outgoingReceiveMethod: "",
            outgoingReceiveMethodConfDictId: "",
            outgoingSendMethod: "",
            outgoingSendMethodConfDictId: "",
            phone: "",
            provinceName: "",
            remarks: "",
            rnRequireConfDictId: "",
            rnRequireCount: "",
            rnRequireName: "",
            sendFee: "",
            sendTime: sendTime,
            dispatchDeptName: departmentName,
            dispatchDeptId: departmentId,
          };

          break;
      }
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        transportPlan: "",
        address: "",
        areaName: "",
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        cityName: "",
        formulaBillingWeight: "",
        formulaBillingWeightId: "",
        freight: "",
        otherFee: "",
        outgoingReceiveMethod: "",
        outgoingReceiveMethodConfDictId: "",
        outgoingSendMethod: "",
        outgoingSendMethodConfDictId: "",
        phone: "",
        provinceName: "",
        remarks: "",
        rnRequireConfDictId: "",
        rnRequireCount: "",
        rnRequireName: "",
        sendFee: "",
        sendTime: "",
        waybillSplitIds: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      let {
        carrierId,
        carrierDeptId,
        outgoingReceiveMethodConfDictId,
        outgoingSendMethodConfDictId,
        formulaBillingWeightId,
        rnRequireConfDictId,
      } = this.dialogForm1;

      //承运商
      let curs1 = this.changeCarrierList.filter(
        (item) => item.carrierId == carrierId
      );
      this.dialogForm1.carrierName =
        (curs1.length && curs1[0].carrierName) || "";

      //承运商网点
      let curs2 = this.CarrierDeptListList.filter(
        (item) => item.carrierDeptId == carrierDeptId
      );
      this.dialogForm1.carrierDeptName =
        (curs2.length && curs2[0].deptName) || "";

      //提货方式
      let curs3 = this.OUTTakeMethodList.filter(
        (item) => item.confDictId == outgoingReceiveMethodConfDictId
      );
      this.dialogForm1.outgoingReceiveMethod =
        (curs3.length && curs3[0].key) || "";

      //外发送货方式
      let curs4 = this.OUTsendMethodList.filter(
        (item) => item.confDictId == outgoingSendMethodConfDictId
      );
      this.dialogForm1.outgoingSendMethod =
        (curs4.length && curs4[0].key) || "";

      //计费方式
      let curs5 = this.out_going_billing_method_list.filter(
        (item) => item.confDictId == formulaBillingWeightId
      );
      this.dialogForm1.formulaBillingWeight =
        (curs5.length && curs5[0].key) || "";

      //回单要求
      let curs6 = this.rnrderRequireList.filter(
        (item) => item.confDictId == rnRequireConfDictId
      );
      this.dialogForm1.rnRequireName = (curs6.length && curs6[0].key) || "";
      if (this.keyOperate == 1) {
        this.$API.waybillwaiFa(this.dialogForm1).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog1 = false;
          this.getData();
        });
      } else if (this.keyOperate == 2 || this.keyOperate == 6) {
        this.$API.updateWaybillDispatch(this.dialogForm1).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog1 = false;
          this.getData();
        });
      }
    },
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        remarks: "",
        storageId: "",
        storageName: "",
        waybillSplitIds: "",
        dispatchDeptName: "",
        dispatchDeptId: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      let { storageId, remarks, waybillSplitIds } = this.dialogForm2;
      if (this.keyOperate == 3) {
        this.$API
          .waybillzhiSong({
            remarks,
            waybillSplitIds,
          })
          .then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.isShowDialog2 = false;
            this.getData();
          });
      } else if (this.keyOperate == 4) {
        let curs1 = this.storageList.filter(
          (item) => item.documentId == storageId
        );
        this.dialogForm2.storageName = (curs1.length && curs1[0].name) || "";
        this.$API.waybillzhuanCang(this.dialogForm2).then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.isShowDialog2 = false;
          this.getData();
        });
      } else if (this.keyOperate == 5) {
        this.$API
          .waybillbatchWaiFa({
            remarks,
            waybillSplitIds,
          })
          .then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.isShowDialog2 = false;
            this.getData();
          });
      }
    },
    //外发承运商
    focusMethodCarrier(e) {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      if (e) {
        // 获取承运商——网点
        let curs = this.changeCarrierList.filter(
          (item) => item.carrierId == e
        )[0];
        this.CarrierDeptListList = [];
        this.dialogForm1.carrierDeptId = "";
        this.CarrierDeptListApi(e);
      }
    },
    //外发承运商网点
    changeMethodCarrier1(e) {
      this.CarrierDeptListList.forEach(async (element) => {
        if (element.carrierDeptId == e) {
          this.dialogForm1.carrierDeptName = element.deptName;
          this.dialogForm1.phone = element.phone;
          this.dialogForm1.contacts = element.contacts || "";
          if (element.provinceName) {
            this.getCityName(element.provinceName);
          }
          if (element.cityName) {
            this.getAreaName(element.cityName);
          }
          this.dialogForm1.provinceName = element.provinceName || "";
          this.dialogForm1.cityName = element.cityName || "";
          this.dialogForm1.areaName = element.areaName || "";
          this.dialogForm1.address = element.address || "";
        }
      });
    },
    CarrierDeptListApi(e) {
      this.$COMAPI.CarrierDeptList(e).then((res) => {
        this.CarrierDeptListList = res || [];
        this.CarrierDeptListList.forEach((element) => {
          if (element.isDefault == 1) {
            this.dialogForm1.carrierDeptId = element.carrierDeptId;
            this.changeMethodCarrier1(this.dialogForm1.carrierDeptId);
          }
        });
      });
    },
    //外发承运商 carrierId carrierName
    remoteMethodCarrier(carrierName) {
      return this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },
    clickSharing_sendFee() {
      if (!this.dialogForm1.carrierId) {
        this.$message.error(`请选择承运商`);
        return false;
      }
      if (!this.dialogForm1.formulaBillingWeightId) {
        this.$message.error(`请选择计费方式`);
        return false;
      }
      this.$API
        .formulafreightCarrierCalculation({
          carrierId: this.dialogForm1.carrierId,
          formulaBillingWeightId: this.dialogForm1.formulaBillingWeightId,
          waybillSplitId: this.dialogForm1.waybillSplitIds[0],
        })
        .then((res) => {
          let datas = res.data.result || {};
          this.dialogForm1.sendFee = datas.sendAmount || "";
          this.dialogForm1.freight = datas.freight || "";
        });
    },
    // 选择回单要求
    changernRequireName(e) {
      // dialogForm1.rnRequireConfDictId
      this.rnrderRequireList.forEach((item) => {
        if (e == item.confDictId) {
          this.dialogForm1.rnRequireName = item.key;
        }
      });
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "out_going_take_method") {
            // 外发提货
            this.OUTTakeMethodList = arrs;
          }
          if (dictType == "out_going_send_method") {
            // 外发送货方式
            this.OUTsendMethodList = arrs;
          }
          if (dictType == "out_going_billing_method") {
            // 外发计费方式
            this.out_going_billing_method_list = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
        });
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.dialogForm1.cityName = "";
      this.dialogForm1.areaName = "";
      this.cityNameList = [];
      this.areaNameList = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.dialogForm1.areaName = "";
      this.areaNameList = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.SuperiorRegionList = res.data.result.data || [];
      });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList = res.data.result.data || [];
        });
    },
    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    // //员工、部门、外发网点
    // changeMethod(e, arrs, keys) {
    //   let curs = this[arrs].filter((item) => item.documentId == e);
    //   if (keys == "intoDeptName") {
    //     this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
    //   } else {
    //     this.commandReq[keys] = (curs.length && curs[0].name) || "";
    //   }
    // },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },
  },
};
</script>
<style scoped lang="less">
.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
  .selectAddress {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: 180px !important;
  }
  .addressDetails {
    width: 380px !important;
  }
}
.miniInput {
  width: 80px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  margin-right: 2px;

  text-align: center;

  /deep/ .el-input__inner {
    text-align: center !important;
    padding: 0 5px;
  }
}

.textArea {
  height: auto !important;
}
.jsBtns {
  height: 30px;
  line-height: 30px;
  margin: 0;
  padding: 0 10px;
  border: none;
}
</style>